function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import iamotaAjax from 'scripts/helpers/iamota-ajax';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import Debug from 'scripts/libs/debug';
var baseUrl = window.Shopify.routes.root;
class AjaxCartApiError extends Error {
  constructor(status, message, description) {
    super(message);
    this.status = status;
    this.description = description;
  }
}
var cart = {
  // Wrapper for the iamotaAjax.post method that throws an error if the response contains a error status
  ajaxPost: function ajaxPost(url) {
    var postData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'cart:post';
    var queryData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    return iamotaAjax.post(url, postData, events, queryData, options).then(response => {
      if (response.status) {
        throw new AjaxCartApiError(response.status, response.message, response.description);
      }
      return response;
    }).catch(error => {
      iamotaEventHandler.trigger(events.error, error);
      throw error;
    });
  },
  add: data => cart.ajaxPost("".concat(baseUrl, "cart/add.js"), data, {
    before: ['cart:modifying:adding'],
    success: [],
    error: ['cart:modifying:error:add']
  }).then(addResult => {
    // Always fetch the new cart state after adding items to trigger the modified event
    // Note: this is needed here because the "add.js" response only contains the new item(s),
    //       whereas "change/update/clear.js" include the full cart object
    return cart.fetch().then(fetchResult => {
      // Merge addResult.sections into fetchResult.sections
      fetchResult.sections = _objectSpread(_objectSpread({}, fetchResult.sections || {}), addResult.sections || {});

      // Trigger the event with the merged sections
      iamotaEventHandler.trigger('cart:modified:added', fetchResult);

      // Return the original response for chaining
      return addResult;
    });
  }),
  addItems: items => cart.add({
    items
  }),
  addItem: item => cart.add({
    items: [item]
  }),
  update: function update(updates) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var changeEvents = cart._getEventsFromChanges({
      updates
    });
    return cart.ajaxPost("".concat(baseUrl, "cart/update.js"), updates, {
      before: [...(events.before || []), ...changeEvents.map(event => "cart:modifying:".concat(event))],
      success: [...(events.success || []), ...changeEvents.map(event => "cart:modified:".concat(event))],
      error: [...(events.error || []), ...changeEvents.map(event => "cart:error:".concat(event))]
    });
  },
  change: function change(_change) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var changeEvents = cart._getEventsFromChanges({
      change: _change
    });
    return cart.ajaxPost("".concat(baseUrl, "cart/change.js"), _change, {
      before: [...(events.before || []), ...changeEvents.map(event => "cart:modifying:".concat(event))],
      success: [...(events.success || []), ...changeEvents.map(event => "cart:modified:".concat(event))],
      error: [...(events.error || []), ...changeEvents.map(event => "cart:error:".concat(event))]
    });
  },
  _getEventsFromChanges: _ref => {
    var change = _ref.change,
      updates = _ref.updates;
    var changesArray = [];
    var changesSet = new Set();

    // If updates are provided, transform them into changes
    if (updates !== null && updates !== void 0 && updates.updates) {
      changesArray = Object.entries(updates.updates).map(_ref2 => {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        if (!isNaN(key)) {
          return {
            line: parseInt(key, 10),
            quantity: value
          };
        }
        return {
          id: key,
          quantity: value
        };
      });
    }

    // If change is provided, add it to the array
    if (change) {
      changesArray.push(change);
    }

    // eslint-disable-next-line no-unused-vars
    changesArray.forEach(entry => {
      var qty = parseInt(entry.quantity, 10);
      if (qty === 0) {
        changesSet.add('remove');
      } else if (!isNaN(qty)) {
        changesSet.add('quantity');
      }
      if ('selling_plan' in entry) {
        if (!entry.selling_plan) {
          changesSet.add('sellingPlan:remove');
        } else {
          changesSet.add('sellingPlan');
        }
      }
      if (entry.properties && typeof entry.properties === 'object') {
        changesSet.add('property');
      }
    });
    var uniqueChanges = Array.from(changesSet);

    // If no changes were detected, default to 'unknown' to minimize knock-on effects
    if (uniqueChanges.length === 0) {
      uniqueChanges.push('unknown');
      Debug.error('Unable to determine what type of change is occuring, defaulting to "unknown"', {
        updates,
        change,
        uniqueChanges,
        changesArray
      });
    }
    return uniqueChanges;
  },
  // Items can be either an array of Line Item Keys or Variant IDs
  removeItems: function removeItems(items) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var updates = items.reduce((updates, key) => {
      updates[key] = 0;
      return updates;
    }, {});
    return cart.update({
      updates
    }, events);
  },
  removeItem: function removeItem(item) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return cart.removeItems([item], events);
  },
  remove: function remove(item) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return cart.removeItem(item, events);
  },
  /**
   * Change the quantity of a line item.
   * @param {number|string} item - Variant ID, line item key, or line index.
   * @param {number} newQuantity - The new quantity for the line item.
   * @param {Object} events - Optional custom events.
   * @returns {Promise} - Returns a promise resolving to the updated cart.
   */
  changeQuantity: function changeQuantity(item, newQuantity) {
    var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return cart.change({
      id: item,
      quantity: newQuantity
    }, events);
  },
  /**
   * Change the selling plan for a line item.
   * @param {number|string} item - Variant ID, line item key, or line index.
   * @param {number} sellingPlanId - The new selling plan ID.
   * @param {Object} events - Optional custom events.
   * @returns {Promise} - Returns a promise resolving to the updated cart.
   */
  changeSellingPlan: function changeSellingPlan(item, sellingPlanId) {
    var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return cart.change({
      id: item,
      selling_plan: sellingPlanId
    }, events);
  },
  /**
   * Remove the selling plan from a line item.
   * @param {number|string} item - Variant ID, line item key, or line index.
   * @param {Object} events - Optional custom events.
   * @returns {Promise} - Returns a promise resolving to the updated cart.
   */
  removeSellingPlan: function removeSellingPlan(item) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return cart.change({
      id: item,
      selling_plan: null
    }, events);
  },
  /**
   * Change the properties of a line item.
   * @param {number|string} item - Variant ID, line item key, or line index.
   * @param {Object} properties - The new properties object.
   * @param {Object} events - Optional custom events.
   * @returns {Promise} - Returns a promise resolving to the updated cart.
   */
  changeLineItemProperties: function changeLineItemProperties(item, properties) {
    var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return cart.change({
      id: item,
      properties
    }, events);
  },
  clear: function clear() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return cart.ajaxPost("".concat(baseUrl, "cart/clear.js"), {}, {
      before: [...(events.before || []), 'cart:modifying:clear'],
      success: [...(events.success || []), 'cart:modified:clear'],
      error: [...(events.error || []), 'cart:error:clear']
    });
  },
  fetch: function fetch() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return iamotaAjax.get("".concat(baseUrl, "cart.js"), {
      before: [...(events.before || []), 'cart:fetching'],
      success: [...(events.success || []), 'cart:fetched'],
      error: [...(events.error || []), 'cart:error:fetch']
    });
  },
  getShippingRates: function getShippingRates(address) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return iamotaAjax.get("".concat(baseUrl, "cart/shipping_rates.json"), {
      before: [...(events.before || []), 'cart:shippingRates:fetching'],
      success: [...(events.success || []), 'cart:shippingRates:fetched'],
      error: [...(events.error || []), 'cart:error:shippingRates:fetch']
    }, address);
  },
  prepareShippingRates: function prepareShippingRates(address) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return cart.ajaxPost("".concat(baseUrl, "cart/prepare_shipping_rates.json"), {}, {
      before: [...(events.before || []), 'cart:shippingRates:preparing'],
      success: [...(events.success || []), 'cart:shippingRates:prepared'],
      error: [...(events.error || []), 'cart:error:shippingRates:prepare']
    }, address);
  },
  asyncShippingRates: function asyncShippingRates(address) {
    var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return iamotaAjax.get("".concat(baseUrl, "cart/async_shipping_rates.json"), {
      before: [...(events.before || []), 'cart:shippingRates:fetchingAsync'],
      success: [...(events.success || []), 'cart:shippingRates:fetchedAsync'],
      error: [...(events.error || []), 'cart:error:shippingRates:fetchAsync']
    }, address);
  }
};
export default cart;